import { List, ListItem, ListItemText } from "@material-ui/core";
import Collapse from "common/components/Collapse/Collapse";
import * as React from "react";
import { Colors } from "styles/Colors";

function NameplateRow({ nameplate, onSelect }) {
	return (
		<ListItem
			button
			style={{ cursor: "pointer", paddingLeft: 24 }}
			onClick={() => onSelect(nameplate)}
		>
			<ListItemText
				primary={
					<>
						{nameplate.name}{" "}
						<span style={{ opacity: 0.55 }}>({nameplate.userCount ?? 0})</span>
					</>
				}
			/>
		</ListItem>
	);
}

function SectionHeader({ name }) {
	return (
		<span style={{ color: Colors.primary, fontWeight: "bold" }}>{name}</span>
	);
}

export default function NameplateTypeList({
	sections,
	untyped,
	onSelectNameplate,
	onCreateNameplate,
}) {
	return (
		<>
			<List>
				<ListItem button style={{ cursor: "pointer" }} onClick={onCreateNameplate}>
					<ListItemText primary="Create New Nameplate" />
				</ListItem>
			</List>

			{sections.map(({ type, nameplates }) => (
				<Collapse
					key={`type-${type.id}`}
					id={`type-${type.id}`}
					startOpen={false}
					headerElement={<SectionHeader name={type.name} />}
				>
					<List disablePadding>
						{nameplates.map((nameplate) => (
							<NameplateRow
								key={nameplate.id}
								nameplate={nameplate}
								onSelect={onSelectNameplate}
							/>
						))}
					</List>
				</Collapse>
			))}

			{untyped.length > 0 && (
				<Collapse
					id="type-untyped"
					startOpen={false}
					headerElement={<SectionHeader name="Untyped" />}
				>
					<List disablePadding>
						{untyped.map((nameplate) => (
							<NameplateRow
								key={nameplate.id}
								nameplate={nameplate}
								onSelect={onSelectNameplate}
							/>
						))}
					</List>
				</Collapse>
			)}
		</>
	);
}
